(() => {
  document.documentElement.classList.remove('no-js');

  const header = document.querySelector('[data-laf-header]');
  const menu = document.querySelector('[data-laf-menu]');
  const openButton = document.querySelector('[data-laf-menu-open]');
  const closeButton = document.querySelector('[data-laf-menu-close]');
  const menuOverlay = document.querySelector('[data-laf-menu-overlay]');
  const navDropdowns = [...document.querySelectorAll('[data-laf-nav-dropdown]')];
  const mobileMenuQuery = window.matchMedia('(max-width: 989px)');
  let menuOpen = false;
  let previousFocus = null;
  let lockedScrollY = 0;

  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const lockPageScroll = () => {
    lockedScrollY = window.scrollY;
    document.documentElement.classList.add('laf-menu-open');
    document.body.classList.add('laf-menu-open');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.width = '100%';
  };

  const unlockPageScroll = () => {
    document.documentElement.classList.remove('laf-menu-open');
    document.body.classList.remove('laf-menu-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  };

  const getMenuFocusables = () => [...(menu?.querySelectorAll(focusableSelector) || [])].filter((element) => !element.hasAttribute('inert'));

  const updateMenuAccessibility = () => {
    if (!menu || !openButton) return;
    const shouldHideMenu = mobileMenuQuery.matches && !menuOpen;

    openButton.setAttribute('aria-expanded', String(menuOpen));
    menu.setAttribute('aria-hidden', String(shouldHideMenu));
    menu.inert = shouldHideMenu;
  };

  const setMenu = (open) => {
    if (!menu || !openButton) return;
    if (open === menuOpen) return;

    menuOpen = open;
    menu.classList.toggle('is-open', open);
    menuOverlay?.classList.toggle('is-visible', open);

    if (open) {
      previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : openButton;
      lockPageScroll();
      updateMenuAccessibility();
      window.requestAnimationFrame(() => {
        const firstTarget = closeButton || getMenuFocusables()[0];
        firstTarget?.focus({ preventScroll: true });
      });
    } else {
      unlockPageScroll();
      updateMenuAccessibility();
      if (previousFocus instanceof HTMLElement && document.contains(previousFocus)) {
        previousFocus.focus({ preventScroll: true });
      }
      previousFocus = null;
    }
  };

  openButton?.addEventListener('click', () => setMenu(true));
  closeButton?.addEventListener('click', () => setMenu(false));
  menuOverlay?.addEventListener('click', () => setMenu(false));

  navDropdowns.forEach((dropdown) => {
    dropdown.addEventListener('toggle', () => {
      if (!dropdown.open) return;
      navDropdowns.forEach((otherDropdown) => {
        if (otherDropdown !== dropdown) otherDropdown.open = false;
      });
    });
  });

  menu?.addEventListener('click', (event) => {
    if (event.target instanceof HTMLAnchorElement) setMenu(false);
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Node)) return;

    if (!mobileMenuQuery.matches) {
      navDropdowns.forEach((dropdown) => {
        if (!dropdown.contains(target)) dropdown.open = false;
      });
      return;
    }

    if (!menuOpen || !menu || !openButton) return;
    if (!menu.contains(target) && !openButton.contains(target)) setMenu(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      navDropdowns.forEach((dropdown) => {
        dropdown.open = false;
      });
      setMenu(false);
      return;
    }

    if (event.key !== 'Tab' || !menuOpen || !mobileMenuQuery.matches) return;

    const focusables = getMenuFocusables();
    if (!focusables.length) {
      event.preventDefault();
      return;
    }

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  });

  const handleMenuBreakpointChange = () => {
    if (!mobileMenuQuery.matches && menuOpen) setMenu(false);
    updateMenuAccessibility();
  };

  if (mobileMenuQuery.addEventListener) {
    mobileMenuQuery.addEventListener('change', handleMenuBreakpointChange);
  } else {
    mobileMenuQuery.addListener(handleMenuBreakpointChange);
  }

  updateMenuAccessibility();

  const updateHeader = () => {
    header?.classList.toggle('is-scrolled', window.scrollY > 8);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const footerMenuQuery = window.matchMedia('(max-width: 749px)');
  const footerMenus = document.querySelectorAll('[data-laf-footer-menu]');

  const setFooterMenu = (menuItem, open) => {
    const toggle = menuItem.querySelector('[data-laf-footer-toggle]');
    const panel = menuItem.querySelector('[data-laf-footer-panel]');
    menuItem.classList.toggle('is-open', open);
    toggle?.setAttribute('aria-expanded', String(open));
    toggle?.setAttribute('tabindex', footerMenuQuery.matches ? '0' : '-1');
    panel?.setAttribute('aria-hidden', String(footerMenuQuery.matches && !open));
    if (panel) panel.hidden = footerMenuQuery.matches && !open;
  };

  const syncFooterMenus = () => {
    footerMenus.forEach((menuItem) => {
      setFooterMenu(menuItem, !footerMenuQuery.matches);
    });
  };

  footerMenus.forEach((menuItem) => {
    const toggle = menuItem.querySelector('[data-laf-footer-toggle]');
    toggle?.addEventListener('click', () => {
      if (!footerMenuQuery.matches) return;
      setFooterMenu(menuItem, !menuItem.classList.contains('is-open'));
    });
  });

  if (footerMenuQuery.addEventListener) {
    footerMenuQuery.addEventListener('change', syncFooterMenus);
  } else {
    footerMenuQuery.addListener(syncFooterMenus);
  }

  syncFooterMenus();

  document.querySelectorAll('[data-laf-carousel-prev], [data-laf-carousel-next]').forEach((button) => {
    button.addEventListener('click', () => {
      const section = button.closest('section');
      const carousel = section?.querySelector('[data-laf-carousel]');
      if (!carousel) return;

      const direction = button.hasAttribute('data-laf-carousel-next') ? 1 : -1;
      const distance = Math.max(280, Math.round(carousel.clientWidth * 0.86));
      carousel.scrollBy({ left: direction * distance, behavior: 'smooth' });
    });
  });

  const updateWellnessCarouselControls = (carousel) => {
    const section = carousel.closest('section');
    if (!section) return;
    const maxScroll = carousel.scrollWidth - carousel.clientWidth - 2;
    const hasOverflow = maxScroll > 2;
    const atStart = carousel.scrollLeft <= 2;
    const atEnd = carousel.scrollLeft >= maxScroll;
    section.classList.toggle('has-carousel-overflow', hasOverflow);

    section.querySelectorAll('[data-wellness-carousel-prev]').forEach((button) => {
      button.disabled = !hasOverflow || atStart;
      button.setAttribute('aria-disabled', String(!hasOverflow || atStart));
    });
    section.querySelectorAll('[data-wellness-carousel-next]').forEach((button) => {
      button.disabled = !hasOverflow || atEnd;
      button.setAttribute('aria-disabled', String(!hasOverflow || atEnd));
    });
  };

  document.querySelectorAll('[data-wellness-carousel]').forEach((carousel) => {
    updateWellnessCarouselControls(carousel);
    carousel.addEventListener('scroll', () => updateWellnessCarouselControls(carousel), { passive: true });
    window.addEventListener('resize', () => updateWellnessCarouselControls(carousel), { passive: true });
  });

  document.querySelectorAll('[data-wellness-carousel-prev], [data-wellness-carousel-next]').forEach((button) => {
    button.addEventListener('click', () => {
      const section = button.closest('section');
      const carousel = section?.querySelector('[data-wellness-carousel]');
      if (!carousel) return;

      const direction = button.hasAttribute('data-wellness-carousel-next') ? 1 : -1;
      const firstCard = carousel.querySelector(':scope > *');
      const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 280;
      const gap = parseFloat(getComputedStyle(carousel).columnGap || getComputedStyle(carousel).gap || 16);
      carousel.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
      window.setTimeout(() => updateWellnessCarouselControls(carousel), 320);
    });
  });

  const getCartBadges = () => document.querySelectorAll('.laf-icon-button--cart span, .cart-badge');

  const animateCartBadges = () => {
    getCartBadges().forEach((badge) => {
      badge.classList.remove('is-updated');
      void badge.offsetWidth;
      badge.classList.add('is-updated');
      window.setTimeout(() => badge.classList.remove('is-updated'), 700);
    });
  };

  const getGlobalCartToast = () => {
    let toast = document.querySelector('[data-global-cart-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'wellness-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    toast.setAttribute('data-global-cart-toast', '');
    document.body.append(toast);
    return toast;
  };

  const renderCartToast = (target, { title, viewCartUrl = '/cart', continueUrl = '/collections/all', error = false }) => {
    const toast = target || getGlobalCartToast();
    toast.classList.add('is-visible');
    toast.classList.toggle('is-error', error);
    toast.replaceChildren();

    const icon = document.createElement('span');
    icon.className = 'wellness-cart-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = error
      ? '<svg viewBox="0 0 24 24"><path d="M12 8v5M12 17h.01M10.3 3.8 2.8 17a2 2 0 0 0 1.7 3h15a2 2 0 0 0 1.7-3L13.7 3.8a2 2 0 0 0-3.4 0Z"></path></svg>'
      : '<svg viewBox="0 0 24 24"><path d="m5 12 4 4L19 6"></path></svg>';

    const content = document.createElement('span');
    content.className = 'wellness-cart-toast__content';

    const message = document.createElement('strong');
    message.textContent = title;
    content.append(message);

    if (!error) {
      const reassurance = document.createElement('small');
      reassurance.textContent = 'Secure checkout, fast UK delivery and independent partner support.';
      content.append(reassurance);
    }

    toast.append(icon, content);

    if (!error) {
      const actions = document.createElement('span');
      actions.className = 'wellness-cart-toast__actions';
      const viewCart = document.createElement('a');
      viewCart.className = 'wellness-cart-toast__button wellness-cart-toast__button--primary';
      viewCart.href = viewCartUrl;
      viewCart.textContent = 'View Cart';
      const continueShopping = document.createElement('a');
      continueShopping.className = 'wellness-cart-toast__button wellness-cart-toast__button--secondary';
      continueShopping.href = continueUrl;
      continueShopping.textContent = 'Continue Shopping';
      actions.append(viewCart, continueShopping);
      toast.append(actions);
    }

    window.clearTimeout(toast._lafHideTimer);
    toast._lafHideTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, error ? 6200 : 5200);
  };

  const updateCartCount = async (animate = false) => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const cart = await response.json();
      getCartBadges().forEach((badge) => {
        badge.textContent = cart.item_count;
        badge.setAttribute('aria-label', `${cart.item_count} items in cart`);
      });
      if (animate) animateCartBadges();
      return cart;
    } catch (error) {
      console.warn('Cart count update failed', error);
      return null;
    }
  };

  const formatCartMoney = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'GBP' });
  };

  const stripSearchHtml = (value = '') => {
    const temp = document.createElement('span');
    temp.innerHTML = value;
    return temp.textContent || temp.innerText || '';
  };

  const getPredictiveSearchImage = (product) => {
    const image = product?.featured_image || product?.image;
    const rawUrl = image?.url || image || '';
    if (!rawUrl) return '';
    return rawUrl.startsWith('//') ? `${window.location.protocol}${rawUrl}` : rawUrl;
  };

  document.querySelectorAll('[data-search-wellness-form]').forEach((form) => {
    const input = form.querySelector('[data-search-wellness-input]');
    const predictive = form.querySelector('[data-search-wellness-predictive]');
    if (!input || !predictive) return;

    let searchTimer;
    let searchController;

    const closePredictive = () => {
      predictive.hidden = true;
      predictive.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
    };

    const renderPredictiveProducts = (products, query) => {
      predictive.replaceChildren();

      if (!products.length) {
        const empty = document.createElement('div');
        empty.className = 'search-wellness__predictive-empty';
        empty.textContent = `No quick matches for "${query}". Press search to see all results.`;
        predictive.append(empty);
      } else {
        const header = document.createElement('div');
        header.className = 'search-wellness__predictive-heading';
        header.textContent = 'Suggested products';
        predictive.append(header);

        products.slice(0, 5).forEach((product) => {
          const item = document.createElement('a');
          item.className = 'search-wellness__predictive-item';
          item.href = product.url || `/search?q=${encodeURIComponent(query)}&type=product`;
          item.setAttribute('role', 'option');

          const media = document.createElement('span');
          media.className = 'search-wellness__predictive-media';
          const imageUrl = getPredictiveSearchImage(product);
          if (imageUrl) {
            const image = document.createElement('img');
            image.src = imageUrl;
            image.alt = stripSearchHtml(product.title || 'Product image');
            image.loading = 'lazy';
            image.decoding = 'async';
            media.append(image);
          }

          const content = document.createElement('span');
          content.className = 'search-wellness__predictive-content';
          const title = document.createElement('strong');
          title.textContent = stripSearchHtml(product.title || 'Product');
          content.append(title);

          if (product.price) {
            const price = document.createElement('span');
            price.textContent = stripSearchHtml(product.price);
            content.append(price);
          }

          item.append(media, content);
          predictive.append(item);
        });

        const allResults = document.createElement('a');
        allResults.className = 'search-wellness__predictive-all';
        allResults.href = `/search?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(query)}`;
        allResults.textContent = 'View all results';
        predictive.append(allResults);
      }

      predictive.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const fetchPredictiveSearch = async (query) => {
      if (searchController) searchController.abort();
      searchController = new AbortController();

      const endpoint = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`;
      const response = await fetch(endpoint, {
        headers: { Accept: 'application/json' },
        signal: searchController.signal
      });

      if (!response.ok) throw new Error('Predictive search unavailable');
      const payload = await response.json();
      return payload?.resources?.results?.products || [];
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      window.clearTimeout(searchTimer);

      if (query.length < 2) {
        closePredictive();
        return;
      }

      searchTimer = window.setTimeout(async () => {
        predictive.hidden = false;
        predictive.replaceChildren();
        const loading = document.createElement('div');
        loading.className = 'search-wellness__predictive-empty';
        loading.textContent = 'Finding products...';
        predictive.append(loading);
        input.setAttribute('aria-expanded', 'true');

        try {
          const products = await fetchPredictiveSearch(query);
          renderPredictiveProducts(products, query);
        } catch (error) {
          if (error.name !== 'AbortError') closePredictive();
        }
      }, 220);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePredictive();
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) closePredictive();
    });
  });

  const getCartItemImageUrl = (item) => {
    const rawUrl = item?.featured_image?.url || item?.image || '';
    if (!rawUrl) return '';
    return rawUrl.startsWith('//') ? `${window.location.protocol}${rawUrl}` : rawUrl;
  };

  const syncCartItemImage = (row, item) => {
    const media = row.querySelector('[data-cart-item-media]');
    if (!media) return;

    const imageUrl = getCartItemImageUrl(item);
    if (!imageUrl) return;

    const altText = item.product_title || item.title || 'Product image';
    let image = media.querySelector('img');

    if (!image) {
      media.replaceChildren();
      image = document.createElement('img');
      image.loading = 'lazy';
      image.decoding = 'async';
      media.append(image);
    }

    if (image.src !== imageUrl) image.src = imageUrl;
    image.alt = altText;
  };

  document.querySelectorAll('[data-main-cart-form]').forEach((cartForm) => {
    const subtotal = cartForm.querySelector('[data-cart-subtotal]');
    const status = cartForm.querySelector('[data-cart-status]');
    const emptyState = document.querySelector('[data-cart-empty-state]');
    const quantityTimers = new WeakMap();

    const setCartStatus = (message) => {
      if (!status) return;
      status.textContent = message;
    };

    const syncCartRows = (cart) => {
      const cartItems = new Map(cart.items.map((item, index) => [item.key, { ...item, line: index + 1 }]));

      cartForm.querySelectorAll('[data-cart-item]').forEach((row) => {
        const item = cartItems.get(row.getAttribute('data-cart-key'));

        if (!item) {
          row.classList.add('is-removing');
          window.setTimeout(() => row.remove(), 220);
          return;
        }

        row.setAttribute('data-cart-line', String(item.line));
        row.querySelector('[data-cart-line-price]').textContent = formatCartMoney(item.final_line_price);
        syncCartItemImage(row, item);
        const input = row.querySelector('[data-cart-quantity-input]');
        if (input) {
          input.value = item.quantity;
          input.setAttribute('data-cart-current', String(item.quantity));
        }
      });

      if (subtotal) subtotal.textContent = formatCartMoney(cart.total_price);

      getCartBadges().forEach((badge) => {
        badge.textContent = cart.item_count;
        badge.setAttribute('aria-label', `${cart.item_count} items in cart`);
      });
      animateCartBadges();

      if (cart.item_count === 0) {
        cartForm.hidden = true;
        emptyState?.removeAttribute('hidden');
      }
    };

    const updateCartLine = async (row, quantity) => {
      if (!row || row.classList.contains('is-loading')) return;

      const input = row.querySelector('[data-cart-quantity-input]');
      const previousQuantity = Number(input?.getAttribute('data-cart-current') || input?.value || 0);
      const line = Number(row.getAttribute('data-cart-line'));
      const nextQuantity = Math.max(0, Number.isFinite(quantity) ? quantity : previousQuantity);

      if (!line || nextQuantity === previousQuantity) return;

      row.classList.add('is-loading');
      row.toggleAttribute('aria-busy', true);
      row.querySelectorAll('button, input').forEach((control) => {
        control.disabled = true;
      });
      if (input) input.value = nextQuantity;
      setCartStatus(nextQuantity === 0 ? 'Removing item...' : 'Updating quantity...');

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ line, quantity: nextQuantity })
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Unable to update your cart.');
        }

        const cart = await response.json();
        syncCartRows(cart);
        setCartStatus(nextQuantity === 0 ? 'Item removed from cart.' : 'Cart updated.');
      } catch (error) {
        if (input) input.value = previousQuantity;
        setCartStatus(error.message);
      } finally {
        row.classList.remove('is-loading');
        row.toggleAttribute('aria-busy', false);
        row.querySelectorAll('button, input').forEach((control) => {
          control.disabled = false;
        });
      }
    };

    cartForm.querySelectorAll('[data-cart-item]').forEach((row) => {
      const input = row.querySelector('[data-cart-quantity-input]');

      row.querySelector('[data-cart-quantity-minus]')?.addEventListener('click', () => {
        updateCartLine(row, Math.max(0, Number(input?.value || 0) - 1));
      });

      row.querySelector('[data-cart-quantity-plus]')?.addEventListener('click', () => {
        updateCartLine(row, Number(input?.value || 0) + 1);
      });

      input?.addEventListener('change', () => {
        window.clearTimeout(quantityTimers.get(input));
        const nextQuantity = Math.max(0, Number(input.value || 0));
        quantityTimers.set(input, window.setTimeout(() => updateCartLine(row, nextQuantity), 280));
      });

      input?.addEventListener('input', () => {
        input.value = input.value.replace(/[^\d]/g, '');
      });

      input?.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        input.blur();
        updateCartLine(row, Math.max(0, Number(input.value || 0)));
      });
    });
  });

  document.querySelectorAll('[data-wellness-quick-add]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const buttonText = form.querySelector('[data-wellness-button-text]');
      const section = form.closest('section');
      const status = section?.querySelector('[data-wellness-cart-status]');
      const originalText = buttonText?.textContent?.trim() || 'Add to Cart';
      const productTitle = form.getAttribute('data-product-title') || 'Product';
      const viewCartUrl = status?.getAttribute('data-view-cart-url') || '/cart';
      const continueUrl = status?.getAttribute('data-continue-url') || '/collections/all';
      const card = form.closest('.wellness-product-card');

      if (!button || button.disabled) return;

      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      card?.classList.remove('is-error', 'is-added');
      card?.classList.add('is-loading');
      if (buttonText) buttonText.textContent = 'Adding...';
      if (status) {
        status.classList.add('is-visible');
        status.classList.remove('is-error');
        status.textContent = `Adding ${productTitle}...`;
      }

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Unable to add product to cart.');
        }

        button.classList.add('is-added');
        card?.classList.add('is-added');
        if (buttonText) buttonText.textContent = 'Added';
        await updateCartCount(true);

        renderCartToast(status, {
          title: `${productTitle} added to cart.`,
          viewCartUrl,
          continueUrl
        });

        window.setTimeout(() => {
          button.classList.remove('is-added');
          card?.classList.remove('is-added');
          if (buttonText) buttonText.textContent = originalText;
          button.disabled = false;
        }, 1800);
      } catch (error) {
        button.classList.add('is-error');
        card?.classList.add('is-error');
        renderCartToast(status, {
          title: error.message,
          viewCartUrl,
          continueUrl,
          error: true
        });
        if (buttonText) buttonText.textContent = originalText;
        button.disabled = false;
        window.setTimeout(() => {
          button.classList.remove('is-error');
          card?.classList.remove('is-error');
        }, 2600);
      } finally {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        card?.classList.remove('is-loading');
      }
    });
  });

  document.querySelectorAll('[data-product-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      document.querySelectorAll('[data-product-variant-select]').forEach((otherSelect) => {
        if (otherSelect !== select) otherSelect.value = select.value;
      });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const panels = gallery.querySelectorAll('[data-product-media-panel]');
    const thumbs = gallery.querySelectorAll('[data-product-media-thumb]');
    const mediaScroller = gallery.querySelector('.wellness-product__main-media');

    const activateMedia = (id, scroll = true) => {
      panels.forEach((panel) => {
        const active = panel.getAttribute('data-product-media-panel') === id;
        panel.classList.toggle('is-active', active);
        if (active && scroll && window.matchMedia('(max-width: 749px)').matches) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      });
      thumbs.forEach((item) => item.classList.toggle('is-active', item.getAttribute('data-product-media-thumb') === id));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.getAttribute('data-product-media-thumb');
        activateMedia(id);
      });
    });

    mediaScroller?.addEventListener('scroll', () => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      const activePanel = [...panels].reduce((closest, panel) => {
        const distance = Math.abs(panel.getBoundingClientRect().left - mediaScroller.getBoundingClientRect().left);
        if (!closest || distance < closest.distance) return { panel, distance };
        return closest;
      }, null)?.panel;
      const id = activePanel?.getAttribute('data-product-media-panel');
      if (!id) return;
      thumbs.forEach((item) => item.classList.toggle('is-active', item.getAttribute('data-product-media-thumb') === id));
    }, { passive: true });
  });

  document.querySelectorAll('[data-quantity-selector]').forEach((selector) => {
    const input = selector.querySelector('[data-quantity-input]');
    selector.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    selector.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    input?.addEventListener('input', () => {
      input.value = input.value.replace(/[^\d]/g, '');
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      select.form?.submit();
    });
  });

  document.querySelectorAll('[data-wellness-product]').forEach((section) => {
    const variantsScript = section.querySelector('[data-product-json]');
    if (!variantsScript) return;

    const variants = JSON.parse(variantsScript.textContent || '[]');
    const optionInputs = section.querySelectorAll('[data-product-option]');
    const variantInput = section.querySelector('[data-product-variant-input]');
    const stickyVariantInput = section.querySelector('[data-sticky-variant-input]');
    const submitButton = section.querySelector('[data-product-submit]');
    const stickySubmit = section.querySelector('[data-sticky-submit]');
    const price = section.querySelector('[data-product-price]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const saleBadge = section.querySelector('[data-product-sale-badge]');
    const stickyAtc = section.querySelector('[data-mobile-sticky-atc]');
    const addLabel = section.getAttribute('data-add-label') || 'Add to Cart';
    const soldLabel = section.getAttribute('data-sold-label') || 'Sold Out';
    const mediaPanels = section.querySelectorAll('[data-product-media-panel]');
    const mediaThumbs = section.querySelectorAll('[data-product-media-thumb]');

    const updateStickyVisibility = () => {
      if (!stickyAtc) return;
      stickyAtc.classList.toggle('is-visible', window.scrollY > 420);
    };

    updateStickyVisibility();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });

    const formatMoney = (cents) => {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'GBP' });
    };

    const selectedOptions = () => {
      const names = [...new Set([...optionInputs].map((input) => input.name))];
      return names.map((name) => section.querySelector(`[name="${CSS.escape(name)}"]:checked`)?.value);
    };

    const updateVariant = () => {
      const options = selectedOptions();
      const currentVariantId = Number(variantInput?.value || stickyVariantInput?.value || 0);
      const variant = options.length
        ? variants.find((item) => item.options.every((option, index) => option === options[index]))
        : variants.find((item) => Number(item.id) === currentVariantId) || variants[0];
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (stickyVariantInput) stickyVariantInput.value = variant.id;

      const priceHtml = `${variant.compare_at_price && variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}<strong>${formatMoney(variant.price)}</strong>`;
      const stickyPriceHtml = `${variant.compare_at_price && variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}${formatMoney(variant.price)}`;
      if (price) price.innerHTML = priceHtml;
      if (stickyPrice) stickyPrice.innerHTML = stickyPriceHtml;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (saleBadge) {
        saleBadge.classList.toggle('is-hidden', !onSale);
        if (onSale) {
          const savings = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          saleBadge.textContent = `Save ${savings}%`;
        }
      }

      [submitButton, stickySubmit].forEach((button) => {
        if (!button) return;
        button.disabled = !variant.available;
        button.textContent = variant.available ? addLabel : soldLabel;
      });

      if (variant.featured_media && variant.featured_media.id) {
        const mediaId = String(variant.featured_media.id);
        mediaPanels.forEach((panel) => panel.classList.toggle('is-active', panel.getAttribute('data-product-media-panel') === mediaId));
        mediaThumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.getAttribute('data-product-media-thumb') === mediaId));
        const activePanel = section.querySelector(`[data-product-media-panel="${CSS.escape(mediaId)}"]`);
        if (activePanel && window.matchMedia('(max-width: 749px)').matches) {
          activePanel.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      }
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
    updateVariant();
  });
})();

(() => {
  const initArchedHeroSliders = (root = document) => {
    const sliders = root.querySelectorAll('[data-arched-hero-slider]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sliders.forEach((slider) => {
      if (slider.dataset.archedHeroReady === 'true') return;
      slider.dataset.archedHeroReady = 'true';

      const slides = [...slider.querySelectorAll('[data-arched-hero-slide]')];
      const dots = [...slider.querySelectorAll('[data-arched-hero-dot]')];
      if (slides.length <= 1) return;

      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      if (current < 0) current = 0;

      const activate = (next) => {
        if (next === current) return;

        const previousSlide = slides[current];
        const nextSlide = slides[next];

        previousSlide.classList.remove('is-active', 'is-entering');
        previousSlide.classList.add('is-exiting');
        nextSlide.classList.add('is-active', 'is-entering');

        dots[current]?.classList.remove('is-active');
        dots[next]?.classList.add('is-active');

        window.setTimeout(() => {
          previousSlide.classList.remove('is-exiting');
          nextSlide.classList.remove('is-entering');
        }, 820);

        current = next;
      };

      if (!reduceMotion) {
        window.setInterval(() => {
          activate((current + 1) % slides.length);
        }, 2000);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initArchedHeroSliders());
  document.addEventListener('shopify:section:load', (event) => initArchedHeroSliders(event.target));
})();

(() => {
  const initCollectionFilters = (root = document) => {
    root.querySelectorAll('[data-collection-filters]').forEach((filters) => {
      if (filters.dataset.filtersReady === 'true') return;
      filters.dataset.filtersReady = 'true';

      const toggle = filters.querySelector('[data-collection-filters-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const isOpen = filters.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initCollectionFilters());
  document.addEventListener('shopify:section:load', (event) => initCollectionFilters(event.target));
})();
